import { Component } from '@angular/core';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
@Component({
  selector: 'app-resgate-reserva',
  templateUrl: './resgate-reserva.component.html',
  styleUrls: ['./resgate-reserva.component.css']
})
export class ResgateReservaComponent {
  reserva: any;
  constructor(private service: SocialSecurityService) {
    this.service.getResgateReserva().subscribe((res: any) => { this.reserva = res; });
  }
}
